import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizeUrl',
})
export class SanitizeUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): any {
    if (value.startsWith('data:image/')) {
      return this.sanitizer.bypassSecurityTrustUrl(value);
    } else {
      return this.sanitizer.bypassSecurityTrustUrl(`${value}`);
    }
  }
}
